// Install snippet's CDN URL resolves through `workspaceApiBase()` so the
// tier matches whatever surface the user is viewing — `dev.api.symbols.app`
// for dev users, `staging.api...` for staging, prod for prod. Previously
// hardcoded `https://api.symbols.app/cdn/...` which sent dev/staging
// users to a stale prod build.
import { workspaceApiBase } from '../functions/workspaceApiBase.js'

export const InstallCdn = {
  P: {
    color: 'inactive',
    margin: '0',
    text: '{{ learn.install.addScript | polyglot }}'
  },
  CodePreviewWithTitle: {
    margin: 'Z1 0 0',
    value: (el) =>
      `<script src="${workspaceApiBase()}/cdn/${el.getAppKey() && el.getAppKey().split('.')[0]}"></script>`,
    Title: null,
    Buttons: {
      FrameworkSwitcher: null
    }
  }
}
